export default __webpack_public_path__ + "static/media/video-search-off-icon.d199b98c.png";